// DO NOT EDIT -- generated from fs/services/dx-objects/appbackend.proto

import { AuditEvent } from './auditlog.proto';
import { DataTable, FunnelMetric } from './datatables.proto';
import { DefinedEventIssueSilence } from './definedevents.proto';
import { Home } from './home.proto';
import { ObjectDeps, VirtualDashboard, VirtualDashboardId } from './model.proto';
import { ObjectType } from './modeltypes.proto';
import { NamedElementIssueSilence } from './namedelements.proto';
import { ObjectReferences } from './objectreferences.proto';
import { UnnamedOverlay } from './overlays.proto';
import { PageIssueSilence } from './pages.proto';
import { PropertyDetail, PropertyIssueSilence } from './properties.proto';
import { UserAccess } from './spaces.proto';
import * as alexa from '../alexa';
import * as display from '../webber/frontend/display';
import * as metrics from '../../api/metrics';
import * as pages from '../../api/pages';
import * as pagination from '../../shared/pagination';
import * as proactiveinsights from '../../api/proactiveinsights';
import * as protobuf from '../../../google/protobuf';
import * as search_settings from '../search-settings';
import * as segment from '../../api/segment';
import * as vars from '../../api/vars';
import * as visualizationsettings from '../search-settings/visualizationsettings';

/** AppBackendPublic is a backend-for-frontend style service to serve DX Objects to FSTA. */
export namespace AppBackendPublic {

  export const ComputeMetricEndpoint = "/grpc/dx_objects.AppBackendPublic/ComputeMetric";
  export function ComputeMetric(sender: (req: ComputeMetricRequest, endpoint: string) => Promise<ComputeMetricResponse>, req: ComputeMetricRequest): { promise: () => Promise<ComputeMetricResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ComputeMetricEndpoint),
      endpoint: ComputeMetricEndpoint
    };
  }

  export const ComputeFunnelMetricEndpoint = "/grpc/dx_objects.AppBackendPublic/ComputeFunnelMetric";
  export function ComputeFunnelMetric(sender: (req: ComputeFunnelMetricRequest, endpoint: string) => Promise<ComputeFunnelMetricResponse>, req: ComputeFunnelMetricRequest): { promise: () => Promise<ComputeFunnelMetricResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ComputeFunnelMetricEndpoint),
      endpoint: ComputeFunnelMetricEndpoint
    };
  }

  export const GetDashboardDetailViewEndpoint = "/grpc/dx_objects.AppBackendPublic/GetDashboardDetailView";
  export function GetDashboardDetailView(sender: (req: GetDashboardDetailViewRequest, endpoint: string) => Promise<GetDashboardDetailViewResponse>, req: GetDashboardDetailViewRequest): { promise: () => Promise<GetDashboardDetailViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDashboardDetailViewEndpoint),
      endpoint: GetDashboardDetailViewEndpoint
    };
  }

  export const GetHeatmapDetailViewEndpoint = "/grpc/dx_objects.AppBackendPublic/GetHeatmapDetailView";
  export function GetHeatmapDetailView(sender: (req: GetHeatmapDetailViewRequest, endpoint: string) => Promise<GetHeatmapDetailViewResponse>, req: GetHeatmapDetailViewRequest): { promise: () => Promise<GetHeatmapDetailViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetHeatmapDetailViewEndpoint),
      endpoint: GetHeatmapDetailViewEndpoint
    };
  }

  export const GetDataTableDetailViewEndpoint = "/grpc/dx_objects.AppBackendPublic/GetDataTableDetailView";
  export function GetDataTableDetailView(sender: (req: GetDataTableDetailViewRequest, endpoint: string) => Promise<GetDataTableDetailViewResponse>, req: GetDataTableDetailViewRequest): { promise: () => Promise<GetDataTableDetailViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDataTableDetailViewEndpoint),
      endpoint: GetDataTableDetailViewEndpoint
    };
  }

  export const GetHomeViewEndpoint = "/grpc/dx_objects.AppBackendPublic/GetHomeView";
  export function GetHomeView(sender: (req: GetHomeViewRequest, endpoint: string) => Promise<GetHomeViewResponse>, req: GetHomeViewRequest): { promise: () => Promise<GetHomeViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetHomeViewEndpoint),
      endpoint: GetHomeViewEndpoint
    };
  }

  export const GetSegmentDetailViewEndpoint = "/grpc/dx_objects.AppBackendPublic/GetSegmentDetailView";
  export function GetSegmentDetailView(sender: (req: GetSegmentDetailViewRequest, endpoint: string) => Promise<GetSegmentDetailViewResponse>, req: GetSegmentDetailViewRequest): { promise: () => Promise<GetSegmentDetailViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSegmentDetailViewEndpoint),
      endpoint: GetSegmentDetailViewEndpoint
    };
  }

  export const GetFunnelDetailViewEndpoint = "/grpc/dx_objects.AppBackendPublic/GetFunnelDetailView";
  export function GetFunnelDetailView(sender: (req: GetFunnelDetailViewRequest, endpoint: string) => Promise<GetFunnelDetailViewResponse>, req: GetFunnelDetailViewRequest): { promise: () => Promise<GetFunnelDetailViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetFunnelDetailViewEndpoint),
      endpoint: GetFunnelDetailViewEndpoint
    };
  }

  export const GetMetricDetailViewEndpoint = "/grpc/dx_objects.AppBackendPublic/GetMetricDetailView";
  export function GetMetricDetailView(sender: (req: GetMetricDetailViewRequest, endpoint: string) => Promise<GetMetricDetailViewResponse>, req: GetMetricDetailViewRequest): { promise: () => Promise<GetMetricDetailViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetMetricDetailViewEndpoint),
      endpoint: GetMetricDetailViewEndpoint
    };
  }

  export const GetJourneyDetailViewEndpoint = "/grpc/dx_objects.AppBackendPublic/GetJourneyDetailView";
  export function GetJourneyDetailView(sender: (req: GetJourneyDetailViewRequest, endpoint: string) => Promise<GetJourneyDetailViewResponse>, req: GetJourneyDetailViewRequest): { promise: () => Promise<GetJourneyDetailViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetJourneyDetailViewEndpoint),
      endpoint: GetJourneyDetailViewEndpoint
    };
  }

  export const GetRetentionMetricDetailViewEndpoint = "/grpc/dx_objects.AppBackendPublic/GetRetentionMetricDetailView";
  export function GetRetentionMetricDetailView(sender: (req: GetRetentionMetricDetailViewRequest, endpoint: string) => Promise<GetRetentionMetricDetailViewResponse>, req: GetRetentionMetricDetailViewRequest): { promise: () => Promise<GetRetentionMetricDetailViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetRetentionMetricDetailViewEndpoint),
      endpoint: GetRetentionMetricDetailViewEndpoint
    };
  }

  export const GetSidebarEndpoint = "/grpc/dx_objects.AppBackendPublic/GetSidebar";
  export function GetSidebar(sender: (req: GetSidebarRequest, endpoint: string) => Promise<GetSidebarResponse>, req: GetSidebarRequest): { promise: () => Promise<GetSidebarResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSidebarEndpoint),
      endpoint: GetSidebarEndpoint
    };
  }

  export const GetNamedElementDetailViewEndpoint = "/grpc/dx_objects.AppBackendPublic/GetNamedElementDetailView";
  export function GetNamedElementDetailView(sender: (req: GetNamedElementDetailViewRequest, endpoint: string) => Promise<GetNamedElementDetailViewResponse>, req: GetNamedElementDetailViewRequest): { promise: () => Promise<GetNamedElementDetailViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetNamedElementDetailViewEndpoint),
      endpoint: GetNamedElementDetailViewEndpoint
    };
  }

  export const GetNamedElementSettingsEndpoint = "/grpc/dx_objects.AppBackendPublic/GetNamedElementSettings";
  export function GetNamedElementSettings(sender: (req: GetNamedElementSettingsRequest, endpoint: string) => Promise<GetNamedElementSettingsResponse>, req: GetNamedElementSettingsRequest): { promise: () => Promise<GetNamedElementSettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetNamedElementSettingsEndpoint),
      endpoint: GetNamedElementSettingsEndpoint
    };
  }

  export const BulkArchiveNamedElementsEndpoint = "/grpc/dx_objects.AppBackendPublic/BulkArchiveNamedElements";
  export function BulkArchiveNamedElements(sender: (req: BulkArchiveNamedElementsRequest, endpoint: string) => Promise<{}>, req: BulkArchiveNamedElementsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, BulkArchiveNamedElementsEndpoint),
      endpoint: BulkArchiveNamedElementsEndpoint
    };
  }

  export const GetDefinedEventDetailViewEndpoint = "/grpc/dx_objects.AppBackendPublic/GetDefinedEventDetailView";
  export function GetDefinedEventDetailView(sender: (req: GetDefinedEventDetailViewRequest, endpoint: string) => Promise<GetDefinedEventDetailViewResponse>, req: GetDefinedEventDetailViewRequest): { promise: () => Promise<GetDefinedEventDetailViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDefinedEventDetailViewEndpoint),
      endpoint: GetDefinedEventDetailViewEndpoint
    };
  }

  export const GetDefinedEventSettingsEndpoint = "/grpc/dx_objects.AppBackendPublic/GetDefinedEventSettings";
  export function GetDefinedEventSettings(sender: (req: GetDefinedEventSettingsRequest, endpoint: string) => Promise<GetDefinedEventSettingsResponse>, req: GetDefinedEventSettingsRequest): { promise: () => Promise<GetDefinedEventSettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDefinedEventSettingsEndpoint),
      endpoint: GetDefinedEventSettingsEndpoint
    };
  }

  export const BulkArchiveDefinedEventsEndpoint = "/grpc/dx_objects.AppBackendPublic/BulkArchiveDefinedEvents";
  export function BulkArchiveDefinedEvents(sender: (req: BulkArchiveDefinedEventsRequest, endpoint: string) => Promise<{}>, req: BulkArchiveDefinedEventsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, BulkArchiveDefinedEventsEndpoint),
      endpoint: BulkArchiveDefinedEventsEndpoint
    };
  }

  export const GetAPIEventDetailViewEndpoint = "/grpc/dx_objects.AppBackendPublic/GetAPIEventDetailView";
  export function GetAPIEventDetailView(sender: (req: GetAPIEventDetailViewRequest, endpoint: string) => Promise<GetAPIEventDetailViewResponse>, req: GetAPIEventDetailViewRequest): { promise: () => Promise<GetAPIEventDetailViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAPIEventDetailViewEndpoint),
      endpoint: GetAPIEventDetailViewEndpoint
    };
  }

  export const SilenceAPIEventIssueEndpoint = "/grpc/dx_objects.AppBackendPublic/SilenceAPIEventIssue";
  export function SilenceAPIEventIssue(sender: (req: SilenceAPIEventIssueRequest, endpoint: string) => Promise<SilenceAPIEventIssueResponse>, req: SilenceAPIEventIssueRequest): { promise: () => Promise<SilenceAPIEventIssueResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SilenceAPIEventIssueEndpoint),
      endpoint: SilenceAPIEventIssueEndpoint
    };
  }

  export const UnSilenceAPIEventIssueEndpoint = "/grpc/dx_objects.AppBackendPublic/UnSilenceAPIEventIssue";
  export function UnSilenceAPIEventIssue(sender: (req: UnSilenceAPIEventIssueRequest, endpoint: string) => Promise<UnSilenceAPIEventIssueResponse>, req: UnSilenceAPIEventIssueRequest): { promise: () => Promise<UnSilenceAPIEventIssueResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnSilenceAPIEventIssueEndpoint),
      endpoint: UnSilenceAPIEventIssueEndpoint
    };
  }

  export const GetVirtualDashboardEndpoint = "/grpc/dx_objects.AppBackendPublic/GetVirtualDashboard";
  export function GetVirtualDashboard(sender: (req: GetVirtualDashboardRequest, endpoint: string) => Promise<GetVirtualDashboardResponse>, req: GetVirtualDashboardRequest): { promise: () => Promise<GetVirtualDashboardResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetVirtualDashboardEndpoint),
      endpoint: GetVirtualDashboardEndpoint
    };
  }

  export const ObjectViewedEndpoint = "/grpc/dx_objects.AppBackendPublic/ObjectViewed";
  export function ObjectViewed(sender: (req: ObjectViewedRequest, endpoint: string) => Promise<{}>, req: ObjectViewedRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, ObjectViewedEndpoint),
      endpoint: ObjectViewedEndpoint
    };
  }

  export const GetPageSettingsEndpoint = "/grpc/dx_objects.AppBackendPublic/GetPageSettings";
  export function GetPageSettings(sender: (req: GetPageSettingsRequest, endpoint: string) => Promise<GetPageSettingsResponse>, req: GetPageSettingsRequest): { promise: () => Promise<GetPageSettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetPageSettingsEndpoint),
      endpoint: GetPageSettingsEndpoint
    };
  }

  export const GetPageDetailViewEndpoint = "/grpc/dx_objects.AppBackendPublic/GetPageDetailView";
  export function GetPageDetailView(sender: (req: GetPageDetailViewRequest, endpoint: string) => Promise<GetPageDetailViewResponse>, req: GetPageDetailViewRequest): { promise: () => Promise<GetPageDetailViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetPageDetailViewEndpoint),
      endpoint: GetPageDetailViewEndpoint
    };
  }

  export const BulkArchivePagesEndpoint = "/grpc/dx_objects.AppBackendPublic/BulkArchivePages";
  export function BulkArchivePages(sender: (req: BulkArchivePagesRequest, endpoint: string) => Promise<{}>, req: BulkArchivePagesRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, BulkArchivePagesEndpoint),
      endpoint: BulkArchivePagesEndpoint
    };
  }

  export const GetPropertySettingsEndpoint = "/grpc/dx_objects.AppBackendPublic/GetPropertySettings";
  export function GetPropertySettings(sender: (req: GetPropertySettingsRequest, endpoint: string) => Promise<GetPropertySettingsResponse>, req: GetPropertySettingsRequest): { promise: () => Promise<GetPropertySettingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetPropertySettingsEndpoint),
      endpoint: GetPropertySettingsEndpoint
    };
  }

  export const GetPropertyDetailViewEndpoint = "/grpc/dx_objects.AppBackendPublic/GetPropertyDetailView";
  export function GetPropertyDetailView(sender: (req: GetPropertyDetailViewRequest, endpoint: string) => Promise<GetPropertyDetailViewResponse>, req: GetPropertyDetailViewRequest): { promise: () => Promise<GetPropertyDetailViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetPropertyDetailViewEndpoint),
      endpoint: GetPropertyDetailViewEndpoint
    };
  }

  export const BulkArchivePropertiesEndpoint = "/grpc/dx_objects.AppBackendPublic/BulkArchiveProperties";
  export function BulkArchiveProperties(sender: (req: BulkArchivePropertiesRequest, endpoint: string) => Promise<{}>, req: BulkArchivePropertiesRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, BulkArchivePropertiesEndpoint),
      endpoint: BulkArchivePropertiesEndpoint
    };
  }

  export const GetInsightDetailViewEndpoint = "/grpc/dx_objects.AppBackendPublic/GetInsightDetailView";
  export function GetInsightDetailView(sender: (req: GetInsightDetailViewRequest, endpoint: string) => Promise<GetInsightDetailViewResponse>, req: GetInsightDetailViewRequest): { promise: () => Promise<GetInsightDetailViewResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetInsightDetailViewEndpoint),
      endpoint: GetInsightDetailViewEndpoint
    };
  }

  export const ComputeDataTableEndpoint = "/grpc/dx_objects.AppBackendPublic/ComputeDataTable";
  export function ComputeDataTable(sender: (req: ComputeDataTableRequest, endpoint: string) => Promise<ComputeDataTableResponse>, req: ComputeDataTableRequest): { promise: () => Promise<ComputeDataTableResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ComputeDataTableEndpoint),
      endpoint: ComputeDataTableEndpoint
    };
  }
}

export interface ComputeMetricRequest {
  orgId: string;
  definition: search_settings.Metric | null;
  timezone: string;
  /** if a user selects "refresh data" on a metric, then we use more aggressive cache options in order to fetch more recent data */
  isRefresh: boolean;
}

export interface ComputeMetricResponse {
  responses: ComputeMetricResponseWithData[];
  cacheOption: alexa.QueryCacheOptions | null;
}

export interface ComputeMetricResponseWithData {
  response: alexa.ComputeMetricResponse | null;
  isTimeRangeComparison: boolean;
}

export interface ComputeFunnelMetricRequest {
  orgId: string;
  definition: search_settings.Funnel | null;
  timezone: string;
  isRefresh: boolean;
}

export interface ComputeFunnelMetricResponse {
  responses: ComputeFunnelMetricResponseWithData[];
  cacheOption: alexa.QueryCacheOptions | null;
}

export interface RevenueFunnelData {
  totalRevenue: number;
  averageOrderValue: number;
}

export interface ComputeFunnelMetricResponseWithData {
  response: alexa.ComputeFunnelMetricsResponse | null;
  isTimeRangeComparison: boolean;
  /** optional - only populated if the funnel is a revenue funnel */
  revenueFunnelData: RevenueFunnelData | null;
}

export interface GetJourneyDetailViewRequest {
  orgId: string;
  journeyId: string;
  unnamedJourneyId: string;
}

export interface GetJourneyDetailViewResponse {
  deps: ObjectDeps | null;
  userAccess: UserAccess | null;
}

export interface GetDashboardDetailViewRequest {
  orgId: string;
  dashboardId: protobuf.int64;
  overlay: UnnamedOverlay | null;
  ignoreSavedOverlay: boolean;
}

export interface GetDashboardDetailViewResponse {
  deps: ObjectDeps | null;
  overlay: UnnamedOverlay | null;
  cardLimit: protobuf.int64;
  userAccess: UserAccess | null;
}

export interface GetHeatmapDetailViewRequest {
  orgId: string;
  heatmapId: string;
  unnamedHeatmapId: string;
  overlay: UnnamedOverlay | null;
}

export interface GetHeatmapDetailViewResponse {
  deps: ObjectDeps | null;
  userAccess: UserAccess | null;
}

export interface GetDataTableDetailViewRequest {
  orgId: string;
  dataTableId: string;
  unnamedDataTableId: string;
}

export interface GetDataTableDetailViewResponse {
  deps: ObjectDeps | null;
  userAccess: UserAccess | null;
}

export interface GetHomeViewRequest {
  orgId: string;
}

export interface GetHomeViewResponse {
  deps: ObjectDeps | null;
  home: Home | null;
  cardLimit: protobuf.int64;
}

export interface GetSegmentDetailViewRequest {
  orgId: string;
  segmentId: string;
  unnamedSegmentId: string;
}

export interface GetSegmentDetailViewResponse {
  deps: ObjectDeps | null;
  userAccess: UserAccess | null;
}

export interface GetFunnelDetailViewRequest {
  orgId: string;
  funnelId: string;
  unnamedFunnelId: string;
  overlay: UnnamedOverlay | null;
}

export interface GetFunnelDetailViewResponse {
  deps: ObjectDeps | null;
  overlay: UnnamedOverlay | null;
  userAccess: UserAccess | null;
}

export interface GetMetricDetailViewRequest {
  orgId: string;
  metricId: string;
  unnamedMetricId: string;
  overlay: UnnamedOverlay | null;
}

export interface GetMetricDetailViewResponse {
  deps: ObjectDeps | null;
  overlay: UnnamedOverlay | null;
  userAccess: UserAccess | null;
}

export interface GetRetentionMetricDetailViewRequest {
  orgId: string;
  retentionMetricId: string;
  unnamedRetentionMetricId: string;
  overlay: UnnamedOverlay | null;
}

export interface GetRetentionMetricDetailViewResponse {
  deps: ObjectDeps | null;
  overlay: UnnamedOverlay | null;
  userAccess: UserAccess | null;
}

export interface GetSidebarRequest {
  orgId: string;
}

export interface GetSidebarResponse {
  deps: ObjectDeps | null;
}

export enum VolumeTimeRange {
  DAY_7 = 0,
  DAY_30 = 1,
  HOUR_72 = 2
}

/** Specific lookback period for long-term volumes. Using an override message for compatibility with defaults. */
export interface VolumeTimeRangeOverride {
  volumeTimeRange: VolumeTimeRange;
}

export enum VolumeAggregateBy {
  DAY = 0,
  HOUR = 1
}

export enum NamedElementStatus {
  NEW = 0,
  ACTIVE = 1,
  INACTIVE = 2
}

export interface GetNamedElementDetailViewRequest {
  orgId: string;
  namedElementId: string;
  timeRange: VolumeTimeRange;
  volumeAggregateBy: VolumeAggregateBy;
  /** Optional timezone, will default to "UTC" if not provided. */
  timezone: string;
}

export interface GetDefinedEventDetailViewRequest {
  orgId: string;
  definedEventId: string;
  timeRange: VolumeTimeRange;
  volumeAggregateBy: VolumeAggregateBy;
  /** Optional timezone, will default to "UTC" if not provided. */
  timezone: string;
}

export interface GetAPIEventDetailViewRequest {
  orgId: string;
  apiEventId?: string;
  apiEventName?: string;
  timeRange: VolumeTimeRange;
  volumeAggregateBy: VolumeAggregateBy;
  /** Optional timezone, will default to "UTC" if not provided. */
  timezone: string;
}

export namespace GetAPIEventDetailViewRequest {
  export enum identifier {
    apiEventId = 2,
    apiEventName = 6
  }

  export function identifier_oneof(m: GetAPIEventDetailViewRequest): { opt: identifier.apiEventId, val: string } | { opt: identifier.apiEventName, val: string } | null {
    if (m.apiEventId != null) { return { opt: identifier.apiEventId, val: m.apiEventId } }
    if (m.apiEventName != null) { return { opt: identifier.apiEventName, val: m.apiEventName } }
    return null;
  }
}

export interface GetAPIEventDetailViewResponse {
  details: GetAPIEventDetailViewResponse.Details | null;
  activityMonitoring?: ActivityMonitoring | null;
  activityMonitoringError?: ActivityMonitoringError | null;
  objectReferences: ObjectReferences | null;
}

export namespace GetAPIEventDetailViewResponse {
  export interface Details {
    /** This is the actual resolved event name */
    name: string;
    /** @deprecated */
    issues: Issues.Issue[];
    issuesData?: Issues | null;
    pending?: Pending | null;
    error?: IssuesError | null;
    silence: APIEventIssueSilence | null;
  }

  export namespace Details {
    export enum issues_state {
      issuesData = 3,
      pending = 4,
      error = 5
    }

    export function issues_state_oneof(m: Details): { opt: issues_state.error, val: IssuesError } | { opt: issues_state.issuesData, val: Issues } | { opt: issues_state.pending, val: Pending } | null {
      if (m.issuesData != null) { return { opt: issues_state.issuesData, val: m.issuesData } }
      if (m.pending != null) { return { opt: issues_state.pending, val: m.pending } }
      if (m.error != null) { return { opt: issues_state.error, val: m.error } }
      return null;
    }
  }

  export enum activity_monitoring_state {
    activityMonitoring = 2,
    activityMonitoringError = 3
  }

  export function activity_monitoring_state_oneof(m: GetAPIEventDetailViewResponse): { opt: activity_monitoring_state.activityMonitoring, val: ActivityMonitoring } | { opt: activity_monitoring_state.activityMonitoringError, val: ActivityMonitoringError } | null {
    if (m.activityMonitoring != null) { return { opt: activity_monitoring_state.activityMonitoring, val: m.activityMonitoring } }
    if (m.activityMonitoringError != null) { return { opt: activity_monitoring_state.activityMonitoringError, val: m.activityMonitoringError } }
    return null;
  }
}

export interface GetPageDetailViewRequest {
  orgId: string;
  pageId: string;
  timeRange: VolumeTimeRange;
  volumeAggregateBy: VolumeAggregateBy;
  /** Optional timezone, will default to "UTC" if not provided. */
  timezone: string;
}

export interface GetPageDetailViewResponse {
  details: GetPageDetailViewResponse.Details | null;
  activityMonitoring?: ActivityMonitoring | null;
  activityMonitoringError?: ActivityMonitoringError | null;
  objectReferences: ObjectReferences | null;
}

export namespace GetPageDetailViewResponse {
  export interface Details {
    page: pages.PageDefinition | null;
    issuesData?: Issues | null;
    pending?: Pending | null;
    error?: IssuesError | null;
    silence: PageIssueSilence | null;
  }

  export namespace Details {
    export enum issues_state {
      issuesData = 7,
      pending = 8,
      error = 9
    }

    export function issues_state_oneof(m: Details): { opt: issues_state.error, val: IssuesError } | { opt: issues_state.issuesData, val: Issues } | { opt: issues_state.pending, val: Pending } | null {
      if (m.issuesData != null) { return { opt: issues_state.issuesData, val: m.issuesData } }
      if (m.pending != null) { return { opt: issues_state.pending, val: m.pending } }
      if (m.error != null) { return { opt: issues_state.error, val: m.error } }
      return null;
    }
  }

  export enum activity_monitoring_state {
    activityMonitoring = 2,
    activityMonitoringError = 3
  }

  export function activity_monitoring_state_oneof(m: GetPageDetailViewResponse): { opt: activity_monitoring_state.activityMonitoring, val: ActivityMonitoring } | { opt: activity_monitoring_state.activityMonitoringError, val: ActivityMonitoringError } | null {
    if (m.activityMonitoring != null) { return { opt: activity_monitoring_state.activityMonitoring, val: m.activityMonitoring } }
    if (m.activityMonitoringError != null) { return { opt: activity_monitoring_state.activityMonitoringError, val: m.activityMonitoringError } }
    return null;
  }
}

export enum PageFilter {
  PAGE_FILTER_DEFAULT = 0,
  PAGE_FILTER_ARCHIVED = 1,
  PAGE_FILTER_CREATED_BY_ME = 2,
  PAGE_FILTER_HAS_ISSUE = 3,
  PAGE_FILTER_API_DEFINED = 4,
  PAGE_FILTER_USER_DEFINED = 5,
  PAGE_FILTER_LEARNED = 6,
  PAGE_FILTER_NATIVE_PLATFORM_WEB = 7,
  PAGE_FILTER_NATIVE_PLATFORM_IOS = 8,
  PAGE_FILTER_NATIVE_PLATFORM_ANDROID = 9,
  PAGE_FILTER_PENDING_SUGGESTED = 10
}

export interface GetPageSettingsRequest {
  orgId: string;
  order: DQMSortOrder | null;
  filters: PageFilter[];
  pageInfo: pagination.PageInfoRequest | null;
  query: string;
  timeRangeOverride: VolumeTimeRangeOverride | null;
  requiresFullIssues: boolean;
  /** Optional timezone, will default to "UTC" if not provided. */
  timezone: string;
}

export interface GetPageSettingsResponse {
  pages: DQMRow[];
  pageInfo: pagination.PageInfoResponse | null;
  sessionQuota: SessionQuota | null;
  activeCount: number;
  archivedCount: number;
  activeLimit: number;
  activeIssuesCount: number;
  apiDefinedCount: number;
  userDefinedCount: number;
  learnedCount: number;
  suggestedCount: number;
}

export enum PropertyFilter {
  PROPERTY_FILTER_DEFAULT = 0,
  PROPERTY_FILTER_ARCHIVED = 1,
  PROPERTY_FILTER_HAS_ISSUE = 2,
  PROPERTY_FILTER_SCOPE_API_EVENT = 3,
  PROPERTY_FILTER_SCOPE_ELEMENT = 4,
  PROPERTY_FILTER_SCOPE_PAGE = 5,
  PROPERTY_FILTER_SCOPE_USER = 6
}

export interface GetPropertySettingsRequest {
  orgId: string;
  order: DQMSortOrder | null;
  filters: PropertyFilter[];
  pageInfo: pagination.PageInfoRequest | null;
  query: string;
  /** Optional timezone, will default to "UTC" if not provided. */
  timezone: string;
  timeRangeOverride: VolumeTimeRangeOverride | null;
  requiresFullIssues: boolean;
}

export interface GetPropertySettingsResponse {
  properties: DQMRow[];
  pageInfo: pagination.PageInfoResponse | null;
  sessionQuota: SessionQuota | null;
  activeCount: number;
  activeIssuesCount: number;
  apiEventPropertyCount: number;
  apiEventPropertyLimit: number;
  elementPropertyCount: number;
  elementPropertyLimit: number;
  pagePropertyCount: number;
  pagePropertyLimit: number;
  userPropertyCount: number;
  userPropertyLimit: number;
}

export interface GetPropertyDetailViewRequest {
  orgId: string;
  /** Uses the standard "<scope>_<name>_<type>" format. */
  propertyId: string;
  timeRange: VolumeTimeRange;
  volumeAggregateBy: VolumeAggregateBy;
  /** Optional timezone, will default to "UTC" if not provided. */
  timezone: string;
}

export interface GetPropertyDetailViewResponse {
  details: GetPropertyDetailViewResponse.Details | null;
  activityMonitoring?: ActivityMonitoring | null;
  activityMonitoringError?: ActivityMonitoringError | null;
  objectReferences: ObjectReferences | null;
}

export namespace GetPropertyDetailViewResponse {
  export interface Details {
    property: PropertyDetail | null;
    issuesData?: Issues | null;
    pending?: Pending | null;
    error?: IssuesError | null;
    silence: PropertyIssueSilence | null;
  }

  export namespace Details {
    export enum issues_state {
      issuesData = 2,
      pending = 3,
      error = 4
    }

    export function issues_state_oneof(m: Details): { opt: issues_state.error, val: IssuesError } | { opt: issues_state.issuesData, val: Issues } | { opt: issues_state.pending, val: Pending } | null {
      if (m.issuesData != null) { return { opt: issues_state.issuesData, val: m.issuesData } }
      if (m.pending != null) { return { opt: issues_state.pending, val: m.pending } }
      if (m.error != null) { return { opt: issues_state.error, val: m.error } }
      return null;
    }
  }

  export enum activity_monitoring_state {
    activityMonitoring = 2,
    activityMonitoringError = 3
  }

  export function activity_monitoring_state_oneof(m: GetPropertyDetailViewResponse): { opt: activity_monitoring_state.activityMonitoring, val: ActivityMonitoring } | { opt: activity_monitoring_state.activityMonitoringError, val: ActivityMonitoringError } | null {
    if (m.activityMonitoring != null) { return { opt: activity_monitoring_state.activityMonitoring, val: m.activityMonitoring } }
    if (m.activityMonitoringError != null) { return { opt: activity_monitoring_state.activityMonitoringError, val: m.activityMonitoringError } }
    return null;
  }
}

export interface SilenceAPIEventIssueRequest {
  orgId: string;
  apiEventId: string;
  expiresAt: protobuf.timestamp | null;
}

export interface SilenceAPIEventIssueResponse {
  issueSilence: APIEventIssueSilence | null;
}

export interface UnSilenceAPIEventIssueRequest {
  orgId: string;
  apiEventId: string;
  issueSilenceId: string;
}

export interface UnSilenceAPIEventIssueResponse {
  issueSilenceId: string;
  apiEventId: string;
}

export interface APIEventIssueSilence {
  id: string;
  apiEventId: string;
  expiresAt: protobuf.timestamp | null;
}

export interface Issues {
  issues: Issues.Issue[];
}

export namespace Issues {
  export interface Issue {
    message: string;
  }
}

export interface IssuesError {
}

export interface Pending {
}

export interface ActivityMonitoring {
  firstSeen: protobuf.timestamp | null;
  lastSeen: protobuf.timestamp | null;
  timeRange: VolumeTimeRange;
  totalEventCount?: protobuf.int64;
  pending?: Pending | null;
  volume: ActivityMonitoring.TimeSeriesDataPoint[];
}

export namespace ActivityMonitoring {
  export interface TimeSeriesDataPoint {
    x: protobuf.timestamp | null;
    y: protobuf.int64;
  }

  export enum event_count {
    totalEventCount = 5,
    pending = 7
  }

  export function event_count_oneof(m: ActivityMonitoring): { opt: event_count.pending, val: Pending } | { opt: event_count.totalEventCount, val: protobuf.int64 } | null {
    if (m.totalEventCount != null) { return { opt: event_count.totalEventCount, val: m.totalEventCount } }
    if (m.pending != null) { return { opt: event_count.pending, val: m.pending } }
    return null;
  }
}

export interface ActivityMonitoringError {
}

export interface GetNamedElementDetailViewResponse {
  details: GetNamedElementDetailViewResponse.Details | null;
  activityMonitoring?: ActivityMonitoring | null;
  activityMonitoringError?: ActivityMonitoringError | null;
  auditHistory: AuditEvent[];
  objectReferences: ObjectReferences | null;
}

export namespace GetNamedElementDetailViewResponse {
  export interface Details {
    namedElement: search_settings.NamedElementRecord | null;
    watched: boolean;
    ignoreRageClicks: boolean;
    ignoreDeadClicks: boolean;
    /** @deprecated */
    issues: Issues.Issue[];
    issuesData?: Issues | null;
    pending?: Pending | null;
    error?: IssuesError | null;
    silence: NamedElementIssueSilence | null;
  }

  export namespace Details {
    export enum issues_state {
      issuesData = 7,
      pending = 8,
      error = 9
    }

    export function issues_state_oneof(m: Details): { opt: issues_state.error, val: IssuesError } | { opt: issues_state.issuesData, val: Issues } | { opt: issues_state.pending, val: Pending } | null {
      if (m.issuesData != null) { return { opt: issues_state.issuesData, val: m.issuesData } }
      if (m.pending != null) { return { opt: issues_state.pending, val: m.pending } }
      if (m.error != null) { return { opt: issues_state.error, val: m.error } }
      return null;
    }
  }

  export enum activity_monitoring_state {
    activityMonitoring = 2,
    activityMonitoringError = 3
  }

  export function activity_monitoring_state_oneof(m: GetNamedElementDetailViewResponse): { opt: activity_monitoring_state.activityMonitoring, val: ActivityMonitoring } | { opt: activity_monitoring_state.activityMonitoringError, val: ActivityMonitoringError } | null {
    if (m.activityMonitoring != null) { return { opt: activity_monitoring_state.activityMonitoring, val: m.activityMonitoring } }
    if (m.activityMonitoringError != null) { return { opt: activity_monitoring_state.activityMonitoringError, val: m.activityMonitoringError } }
    return null;
  }
}

export interface GetDefinedEventDetailViewResponse {
  details: GetDefinedEventDetailViewResponse.Details | null;
  activityMonitoring?: ActivityMonitoring | null;
  activityMonitoringError?: ActivityMonitoringError | null;
  objectReferences: ObjectReferences | null;
}

export namespace GetDefinedEventDetailViewResponse {
  export interface Details {
    definedEvent: search_settings.DefinedEventRecord | null;
    watched: boolean;
    ignoreRageClicks: boolean;
    ignoreDeadClicks: boolean;
    /** @deprecated */
    issues: Issues.Issue[];
    issuesData?: Issues | null;
    pending?: Pending | null;
    error?: IssuesError | null;
    silence: DefinedEventIssueSilence | null;
  }

  export namespace Details {
    export enum issues_state {
      issuesData = 7,
      pending = 8,
      error = 9
    }

    export function issues_state_oneof(m: Details): { opt: issues_state.error, val: IssuesError } | { opt: issues_state.issuesData, val: Issues } | { opt: issues_state.pending, val: Pending } | null {
      if (m.issuesData != null) { return { opt: issues_state.issuesData, val: m.issuesData } }
      if (m.pending != null) { return { opt: issues_state.pending, val: m.pending } }
      if (m.error != null) { return { opt: issues_state.error, val: m.error } }
      return null;
    }
  }

  export enum activity_monitoring_state {
    activityMonitoring = 2,
    activityMonitoringError = 3
  }

  export function activity_monitoring_state_oneof(m: GetDefinedEventDetailViewResponse): { opt: activity_monitoring_state.activityMonitoring, val: ActivityMonitoring } | { opt: activity_monitoring_state.activityMonitoringError, val: ActivityMonitoringError } | null {
    if (m.activityMonitoring != null) { return { opt: activity_monitoring_state.activityMonitoring, val: m.activityMonitoring } }
    if (m.activityMonitoringError != null) { return { opt: activity_monitoring_state.activityMonitoringError, val: m.activityMonitoringError } }
    return null;
  }
}

export enum NamedElementFilter {
  FILTER_DEFAULT = 0,
  FILTER_ARCHIVED = 1,
  FILTER_CREATED_BY_ME = 2,
  FILTER_HAS_ISSUE = 3,
  FILTER_WATCHED = 4,
  FILTER_IGNORED_DEAD_CLICK = 5,
  FILTER_IGNORED_RAGE_CLICK = 6,
  FILTER_NATIVE_PLATFORM_WEB = 7,
  FILTER_NATIVE_PLATFORM_IOS = 8,
  FILTER_NATIVE_PLATFORM_ANDROID = 9,
  FILTER_PENDING_SUGGESTED = 10
}

export enum DefinedEventFilter {
  EVENT_FILTER_DEFAULT = 0,
  EVENT_FILTER_ARCHIVED = 1,
  EVENT_FILTER_CREATED_BY_ME = 2,
  EVENT_FILTER_HAS_ISSUE = 3,
  EVENT_FILTER_CUSTOM_API_EVENT = 4,
  EVENT_FILTER_DEFINED_EVENT = 5
}

export enum EventType {
  /** Meant to indicate that the event type is n/a, ex. for named elements */
  EVENT_TYPE_NOT_APPLICABLE = 0,
  EVENT_TYPE_DEFINED_EVENT = 1,
  EVENT_TYPE_CUSTOM_API_EVENT = 2
}

export interface GetNamedElementSettingsRequest {
  orgId: string;
  order: DQMSortOrder | null;
  filters: NamedElementFilter[];
  pageInfo: pagination.PageInfoRequest | null;
  query: string;
  timezone: string;
  timeRangeOverride: VolumeTimeRangeOverride | null;
  requiresFullIssues: boolean;
}

export interface GetDefinedEventSettingsRequest {
  orgId: string;
  order: DQMSortOrder | null;
  filters: DefinedEventFilter[];
  pageInfo: pagination.PageInfoRequest | null;
  query: string;
  timezone: string;
  timeRangeOverride: VolumeTimeRangeOverride | null;
  requiresFullIssues: boolean;
}

export interface DQMSortOrder {
  by: DQMSortOrder.By;
  direction: DQMSortOrder.Direction;
}

export namespace DQMSortOrder {
  export enum By {
    /** This is the default sort. It is important to be field 0 so that it is the zero value of the enum. */
    BY_DEFAULT = 0,
    BY_NAME = 1,
    BY_CREATOR = 2,
    BY_LAST_MODIFIED = 3,
    BY_VOLUME_COUNT = 4,
    BY_ISSUE_COUNT = 5,
    BY_OBJECT_REFERENCE_COUNT = 6
  }

  export enum Direction {
    DIRECTION_DEFAULT = 0,
    DIRECTION_ASC = 1,
    DIRECTION_DESC = 2
  }
}

export interface SessionQuota {
  quotaExceeded: boolean;
  quotaCycleReset: protobuf.timestamp | null;
}

export interface DQMRow {
  id: string;
  name: string;
  createdBy: string;
  lastModified: protobuf.timestamp | null;
  /** @deprecated */
  status: NamedElementStatus;
  volume30DayCount?: protobuf.int64;
  volumePending?: DQMRow.Pending | null;
  volumeError?: DQMRow.Error | null;
  volumeTimeRangeCount?: protobuf.int64;
  issueCount?: number;
  issuesPending?: DQMRow.Pending | null;
  issuesError?: DQMRow.Error | null;
  archived: boolean;
  eventSupport: DQMRow.EventSupport;
  eventType: EventType;
  /** The number of objects that reference this element */
  objectReferenceCount: protobuf.int64;
  /** Specific fields for pages */
  isUserDefined: boolean;
  friendlyId: string;
  labels: pages.LabelRule[];
  patterns: pages.PatternRule[];
  confidenceScore: number;
  /** Specific fields for suggestions (elements and pages) */
  suggestionId: string;
  /** Specific fields for properties */
  propertyScope: vars.Scope;
  propertyType: vars.Type;
  pendingProperty: boolean;
}

export namespace DQMRow {
  export interface Pending {
  }

  export interface Error {
  }

  export enum EventSupport {
    /** Meant to indicate that the event support state is n/a */
    EVENT_SUPPORT_NOT_APPLICABLE = 0,
    EVENT_SUPPORT_SUPPORTED = 1,
    EVENT_SUPPORT_UNSUPPORTED = 2
  }

  export enum volume {
    volume30DayCount = 6,
    volumePending = 9,
    volumeError = 10,
    volumeTimeRangeCount = 20
  }

  export function volume_oneof(m: DQMRow): { opt: volume.volume30DayCount, val: protobuf.int64 } | { opt: volume.volumeError, val: DQMRow.Error } | { opt: volume.volumePending, val: DQMRow.Pending } | { opt: volume.volumeTimeRangeCount, val: protobuf.int64 } | null {
    if (m.volume30DayCount != null) { return { opt: volume.volume30DayCount, val: m.volume30DayCount } }
    if (m.volumePending != null) { return { opt: volume.volumePending, val: m.volumePending } }
    if (m.volumeError != null) { return { opt: volume.volumeError, val: m.volumeError } }
    if (m.volumeTimeRangeCount != null) { return { opt: volume.volumeTimeRangeCount, val: m.volumeTimeRangeCount } }
    return null;
  }

  export enum issues {
    issueCount = 7,
    issuesPending = 11,
    issuesError = 12
  }

  export function issues_oneof(m: DQMRow): { opt: issues.issueCount, val: number } | { opt: issues.issuesError, val: DQMRow.Error } | { opt: issues.issuesPending, val: DQMRow.Pending } | null {
    if (m.issueCount != null) { return { opt: issues.issueCount, val: m.issueCount } }
    if (m.issuesPending != null) { return { opt: issues.issuesPending, val: m.issuesPending } }
    if (m.issuesError != null) { return { opt: issues.issuesError, val: m.issuesError } }
    return null;
  }
}

export interface GetNamedElementSettingsResponse {
  namedElements: DQMRow[];
  pageInfo: pagination.PageInfoResponse | null;
  sessionQuota: SessionQuota | null;
  /** The count and limit of active elements. If length of active (i.e. non archived) elements are at or over limit, new elements will not be allowed. */
  activeCount: number;
  activeLimit: number;
  activeIssuesCount: number;
}

export interface GetDefinedEventSettingsResponse {
  definedEvents: DQMRow[];
  pageInfo: pagination.PageInfoResponse | null;
  sessionQuota: SessionQuota | null;
  /** The count and limit of active events. If length of active (i.e. non archived) events are at or over limit, new events will not be allowed. */
  activeCount: number;
  activeLimit: number;
  activeIssuesCount: number;
  customApiEventCount: number;
  definedEventCount: number;
}

export interface BulkArchiveNamedElementsRequest {
  orgId: string;
  archive: boolean;
  filters: NamedElementFilter[];
  query: string;
  /** If provided, only elements that were updated before this will be affected. */
  lastUpdatedBefore: protobuf.timestamp | null;
}

export interface BulkArchiveDefinedEventsRequest {
  orgId: string;
  archive: boolean;
  filters: DefinedEventFilter[];
  query: string;
  /** If provided, only events that were updated before this will be affected. */
  lastUpdatedBefore: protobuf.timestamp | null;
}

export interface BulkArchivePagesRequest {
  orgId: string;
  filters: PageFilter[];
  query: string;
  /** If provided, only pages that were updated before this will be affected. */
  lastUpdatedBefore: protobuf.timestamp | null;
  /** If provided, only pages with a volume less than this will be affected. */
  volumeThreshold: protobuf.int64;
  /** If provided, only pages with a reference count less than this will be affected. */
  referenceThreshold: protobuf.int64;
}

export interface BulkArchivePropertiesRequest {
  orgId: string;
  archive: boolean;
  filters: PropertyFilter[];
  query: string;
  /** If provided, only properties that were updated before this will be affected. */
  lastUpdatedBefore: protobuf.timestamp | null;
}

export interface GetVirtualDashboardRequest {
  orgId: string;
  pageId?: number;
  uncaughtException?: string;
  namedElementId?: string;
  consoleError?: string;
  customEventName?: string;
  visitedUrl?: string;
  text?: string;
  ajaxErrorUrl?: string;
  css?: string;
  email?: string;
  /** Each template should have a structure for it's expected inputs */
  usersUser?: GetVirtualDashboardRequest.UsersUser | null;
  definedEvent?: string;
  rageClick?: GetVirtualDashboardRequest.Element | null;
  errorClick?: GetVirtualDashboardRequest.Element | null;
  deadClick?: GetVirtualDashboardRequest.Element | null;
  networkError?: GetVirtualDashboardRequest.NetworkError | null;
  funnel?: search_settings.Funnel | null;
  funnelsRevenue?: GetVirtualDashboardRequest.FunnelsRevenue | null;
  crashed?: boolean;
  lowMemory?: boolean;
  /** @deprecated */
  insightSingle?: GetVirtualDashboardRequest.InsightSingle | null;
  /** @deprecated */
  insightDual?: GetVirtualDashboardRequest.InsightDual | null;
  insightCommon?: GetVirtualDashboardRequest.InsightCommon | null;
  insightImpact?: GetVirtualDashboardRequest.InsightImpact | null;
  insightOverview?: GetVirtualDashboardRequest.InsightOverview | null;
  insightFunnelError?: GetVirtualDashboardRequest.InsightFunnelError | null;
  id: VirtualDashboardId;
  overlay: UnnamedOverlay | null;
}

export namespace GetVirtualDashboardRequest {
  export interface UsersUser {
    email: string;
    customEvent?: string;
    definedEvent?: string;
    eventProperty: string;
    currency: display.DisplayCurrencyType;
  }

  export namespace UsersUser {
    export enum event {
      customEvent = 2,
      definedEvent = 5
    }

    export function event_oneof(m: UsersUser): { opt: event.customEvent, val: string } | { opt: event.definedEvent, val: string } | null {
      if (m.customEvent != null) { return { opt: event.customEvent, val: m.customEvent } }
      if (m.definedEvent != null) { return { opt: event.definedEvent, val: m.definedEvent } }
      return null;
    }
  }

  export interface NetworkError {
    url: string;
    statusCode: string;
    requestMethod: string;
  }

  export interface Element {
    cssSelector?: string;
    namedElementId?: string;
  }

  export namespace Element {
    export enum element_type {
      cssSelector = 1,
      namedElementId = 2
    }

    export function element_type_oneof(m: Element): { opt: element_type.cssSelector, val: string } | { opt: element_type.namedElementId, val: string } | null {
      if (m.cssSelector != null) { return { opt: element_type.cssSelector, val: m.cssSelector } }
      if (m.namedElementId != null) { return { opt: element_type.namedElementId, val: m.namedElementId } }
      return null;
    }
  }

  export interface FunnelsRevenue {
    segmentDefinition: segment.SegmentDefinition | null;
    definedEvent: string;
    eventProperty: string;
    currency: display.DisplayCurrencyType;
  }

  export interface InsightSingle {
    event: segment.Event | null;
    timeRange: segment.TimeRange | null;
    display: display.Display | null;
  }

  export interface InsightDual {
    measure: metrics.DualMeasure | null;
    timeRange: segment.TimeRange | null;
    display: display.Display | null;
  }

  export interface InsightCommon {
    metric: metrics.Metric | null;
    timeRange: segment.TimeRange | null;
    display: display.Display | null;
    aggregation: metrics.Aggregation | null;
  }

  export interface InsightImpact {
    common: GetVirtualDashboardRequest.InsightCommon | null;
    scopedPageId: number;
    scopedDomain: string;
    scopedUserPercentageTitle: string;
  }

  export interface InsightOverview {
    common: GetVirtualDashboardRequest.InsightCommon | null;
    firstSeenTitle: string;
  }

  export interface InsightFunnelError {
    common: GetVirtualDashboardRequest.InsightCommon | null;
    title: string;
    segmentSetting: visualizationsettings.SegmentSettings | null;
  }

  export enum variable {
    pageId = 2,
    uncaughtException = 3,
    namedElementId = 6,
    consoleError = 7,
    customEventName = 8,
    visitedUrl = 9,
    text = 10,
    ajaxErrorUrl = 11,
    css = 12,
    email = 13,
    /** Each template should have a structure for it's expected inputs */
    usersUser = 14,
    definedEvent = 15,
    rageClick = 16,
    errorClick = 17,
    deadClick = 18,
    networkError = 19,
    funnel = 20,
    funnelsRevenue = 21,
    crashed = 22,
    lowMemory = 23,
    /** @deprecated */
    insightSingle = 24,
    /** @deprecated */
    insightDual = 25,
    insightCommon = 26,
    insightImpact = 27,
    insightOverview = 28,
    insightFunnelError = 29
  }

  export function variable_oneof(m: GetVirtualDashboardRequest): { opt: variable.ajaxErrorUrl, val: string } | { opt: variable.consoleError, val: string } | { opt: variable.crashed, val: boolean } | { opt: variable.css, val: string } | { opt: variable.customEventName, val: string } | { opt: variable.deadClick, val: GetVirtualDashboardRequest.Element } | { opt: variable.definedEvent, val: string } | { opt: variable.email, val: string } | { opt: variable.errorClick, val: GetVirtualDashboardRequest.Element } | { opt: variable.funnel, val: search_settings.Funnel } | { opt: variable.funnelsRevenue, val: GetVirtualDashboardRequest.FunnelsRevenue } | { opt: variable.insightCommon, val: GetVirtualDashboardRequest.InsightCommon } | { opt: variable.insightDual, val: GetVirtualDashboardRequest.InsightDual } | { opt: variable.insightFunnelError, val: GetVirtualDashboardRequest.InsightFunnelError } | { opt: variable.insightImpact, val: GetVirtualDashboardRequest.InsightImpact } | { opt: variable.insightOverview, val: GetVirtualDashboardRequest.InsightOverview } | { opt: variable.insightSingle, val: GetVirtualDashboardRequest.InsightSingle } | { opt: variable.lowMemory, val: boolean } | { opt: variable.namedElementId, val: string } | { opt: variable.networkError, val: GetVirtualDashboardRequest.NetworkError } | { opt: variable.pageId, val: number } | { opt: variable.rageClick, val: GetVirtualDashboardRequest.Element } | { opt: variable.text, val: string } | { opt: variable.uncaughtException, val: string } | { opt: variable.usersUser, val: GetVirtualDashboardRequest.UsersUser } | { opt: variable.visitedUrl, val: string } | null {
    if (m.pageId != null) { return { opt: variable.pageId, val: m.pageId } }
    if (m.uncaughtException != null) { return { opt: variable.uncaughtException, val: m.uncaughtException } }
    if (m.namedElementId != null) { return { opt: variable.namedElementId, val: m.namedElementId } }
    if (m.consoleError != null) { return { opt: variable.consoleError, val: m.consoleError } }
    if (m.customEventName != null) { return { opt: variable.customEventName, val: m.customEventName } }
    if (m.visitedUrl != null) { return { opt: variable.visitedUrl, val: m.visitedUrl } }
    if (m.text != null) { return { opt: variable.text, val: m.text } }
    if (m.ajaxErrorUrl != null) { return { opt: variable.ajaxErrorUrl, val: m.ajaxErrorUrl } }
    if (m.css != null) { return { opt: variable.css, val: m.css } }
    if (m.email != null) { return { opt: variable.email, val: m.email } }
    if (m.usersUser != null) { return { opt: variable.usersUser, val: m.usersUser } }
    if (m.definedEvent != null) { return { opt: variable.definedEvent, val: m.definedEvent } }
    if (m.rageClick != null) { return { opt: variable.rageClick, val: m.rageClick } }
    if (m.errorClick != null) { return { opt: variable.errorClick, val: m.errorClick } }
    if (m.deadClick != null) { return { opt: variable.deadClick, val: m.deadClick } }
    if (m.networkError != null) { return { opt: variable.networkError, val: m.networkError } }
    if (m.funnel != null) { return { opt: variable.funnel, val: m.funnel } }
    if (m.funnelsRevenue != null) { return { opt: variable.funnelsRevenue, val: m.funnelsRevenue } }
    if (m.crashed != null) { return { opt: variable.crashed, val: m.crashed } }
    if (m.lowMemory != null) { return { opt: variable.lowMemory, val: m.lowMemory } }
    if (m.insightSingle != null) { return { opt: variable.insightSingle, val: m.insightSingle } }
    if (m.insightDual != null) { return { opt: variable.insightDual, val: m.insightDual } }
    if (m.insightCommon != null) { return { opt: variable.insightCommon, val: m.insightCommon } }
    if (m.insightImpact != null) { return { opt: variable.insightImpact, val: m.insightImpact } }
    if (m.insightOverview != null) { return { opt: variable.insightOverview, val: m.insightOverview } }
    if (m.insightFunnelError != null) { return { opt: variable.insightFunnelError, val: m.insightFunnelError } }
    return null;
  }
}

export interface GetVirtualDashboardResponse {
  dashboard: VirtualDashboard | null;
  deps: ObjectDeps | null;
}

export interface ObjectViewedRequest {
  orgId: string;
  dxObjectId: string;
  dxObjectType: ObjectType;
}

export interface GetInsightDetailViewRequest {
  orgId: string;
  dxId: string;
  dxObjectType: proactiveinsights.SupportedDxObjectType;
}

export interface GetInsightDetailViewResponse {
  insights: proactiveinsights.Insight[];
  deps: ObjectDeps | null;
}

export interface ComputeDataTableRequest {
  orgId: string;
  dataTable?: DataTable | null;
  dataTableId?: string;
  unnamedDataTableId?: string;
  timezone: string;
  /** if a user selects "refresh data" on a metric, then we use more aggressive cache options in order to fetch more recent data */
  isRefresh: boolean;
  breakdown: DataTableBreakdown[];
}

export namespace ComputeDataTableRequest {
  export enum definition {
    dataTable = 2,
    dataTableId = 3,
    unnamedDataTableId = 4
  }

  export function definition_oneof(m: ComputeDataTableRequest): { opt: definition.dataTable, val: DataTable } | { opt: definition.dataTableId, val: string } | { opt: definition.unnamedDataTableId, val: string } | null {
    if (m.dataTable != null) { return { opt: definition.dataTable, val: m.dataTable } }
    if (m.dataTableId != null) { return { opt: definition.dataTableId, val: m.dataTableId } }
    if (m.unnamedDataTableId != null) { return { opt: definition.unnamedDataTableId, val: m.unnamedDataTableId } }
    return null;
  }
}

export interface DataTableBreakdown {
  /** Used for a single dimension value. E.g., 'Kids' or a time value: e.g., '2024-10-23T05:00:00Z' */
  dimension?: DataTableBreakdown.DataTableDimensionValue | null;
  dimensionGroup?: DataTableBreakdown.DataTableDimensionGroup | null;
}

export namespace DataTableBreakdown {
  /** A grouping is used for things like city (city + state) or resolution (height + width) which should be treated as combination of multiple dimensions. */
  export interface DataTableDimensionGroup {
    values: string[];
  }

  export interface DataTableDimensionValue {
    value: string;
  }

  export enum dimension_value {
    /** Used for a single dimension value. E.g., 'Kids' or a time value: e.g., '2024-10-23T05:00:00Z' */
    dimension = 1,
    dimensionGroup = 2
  }

  export function dimension_value_oneof(m: DataTableBreakdown): { opt: dimension_value.dimension, val: DataTableBreakdown.DataTableDimensionValue } | { opt: dimension_value.dimensionGroup, val: DataTableBreakdown.DataTableDimensionGroup } | null {
    if (m.dimension != null) { return { opt: dimension_value.dimension, val: m.dimension } }
    if (m.dimensionGroup != null) { return { opt: dimension_value.dimensionGroup, val: m.dimensionGroup } }
    return null;
  }
}

export interface ComputeDataTableResponse {
  response: ComputeDataTableDataResponse | null;
  cacheOption: alexa.QueryCacheOptions | null;
}

export interface ComputeDataTableSegmentRow {
  segment: visualizationsettings.SegmentSettings | null;
  rows: ComputeDataTableResponseRow[];
}

export interface ComputeDataTableDataResponse {
  columns: ComputeDataTableResponseColumn[];
  breakdown: DataTableBreakdown[];
  /**
   * TODO Remove once UI is full migrated off
   * 
   * @deprecated
   */
  rows: ComputeDataTableResponseRow[];
  segmentRows: ComputeDataTableSegmentRow[];
}

export interface ComputeDataTableResponseColumn {
  metricColumn?: ComputeDataTableResponseColumn.MetricColumnValues | null;
  funnelColumn?: ComputeDataTableResponseColumn.FunnelColumnValues | null;
}

export namespace ComputeDataTableResponseColumn {
  export interface MetricColumnValues {
    metricId: string;
    displayAs: display.Display | null;
  }

  export interface FunnelColumnValues {
    funnelId: string;
    funnelMetric: FunnelMetric;
  }

  export enum column_type {
    metricColumn = 1,
    funnelColumn = 2
  }

  export function column_type_oneof(m: ComputeDataTableResponseColumn): { opt: column_type.funnelColumn, val: ComputeDataTableResponseColumn.FunnelColumnValues } | { opt: column_type.metricColumn, val: ComputeDataTableResponseColumn.MetricColumnValues } | null {
    if (m.metricColumn != null) { return { opt: column_type.metricColumn, val: m.metricColumn } }
    if (m.funnelColumn != null) { return { opt: column_type.funnelColumn, val: m.funnelColumn } }
    return null;
  }
}

export interface ComputeDataTableResponseRow {
  /** The dimension group values, which can include a time value. E.g., ['Kids', '2024-10-23T05:00:00Z'] */
  groups: string[];
  values: number[];
}

export interface ComputeDataTableMetricResponse {
  /** The dimension group values, which can include a time value. E.g., ['Kids', '2024-10-23T05:00:00Z'] */
  groups: string[];
  value: number;
}

export interface ComputeDataTableFunnelResponse {
  /** The dimension group values, which can include a time value. E.g., ['Kids', '2024-10-23T05:00:00Z'] */
  groups: string[];
  value: number;
}
